<template>
  <div id="admin">
    <v-tabs right class="mb-5">
      <v-tab
        v-for="(nav, nv) in adminNav"
        :key="nv"
        :to="{ name: nav.route }"
      >
        {{ nav.title }}
      </v-tab>
    </v-tabs>

    <router-view></router-view>

  </div>
</template>

<script>
  export default {
    name: 'Admin',

    data: () => ({
      adminNav: [
        {
          title: 'Assets',
          route: 'adminAssets'
        },
        {
          title: 'Types',
          route: 'adminAssetTypes'
        },
        {
          title: 'Consignors',
          route: 'adminConsignors'
        },
        {
          title: 'Users',
          route: 'adminUsers'
        },
        {
          title: 'Withdrawals',
          route: 'adminPayout'
        },
        {
          title: 'Pending Payments',
          route: 'adminPendingPayments'
        },
        {
          title: 'Reports',
          route: 'adminReports'
        }
      ]
    })
  }
</script>
